export default __webpack_public_path__ + "static/media/order-details.2a5655ae.png";